var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":_vm.flag,"height":"16"}}),(!_vm.hideText)?_c('span',[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.text))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }